import React from 'react'

const Skill = () => {
    return (
      <div className="flex flex-wrap">
        <div className="w-full">
          <div className="md:mx-4">
            <h3 className="text-2xl text-gray-800 font-bold mb-4 mt-8">Technical Skills</h3>
          </div>
        </div>
        <div className="text-left mx-4">
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">C++</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Kotlin</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Java</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">PHP</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Python</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">HTML</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">CSS</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">SQL</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Firebase</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Laravel</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">TailwindCSS</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Vue.js</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">React.js</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Figma</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Github</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">Android Studio</span>
          <span className="inline-block rounded-full text-white bg-purple-500 px-4 py-1 text-l mr-3 my-2">VSCode</span>
        </div>
      </div>
    )
}

export default Skill
